import React from 'react';
import classNames from 'classnames';
import styles from 'src/components/icons/Icons.module.scss';
import PropTypes from 'prop-types';

const rotationMap = {
    up: 'rotation-90',
    right: 'rotation180',
    down: 'rotation90',
    left: null
};

export const IconArrow = ({ rotation = 'down', className, ...props }) => (

<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNames(styles.svg, className, styles[rotationMap[rotation]])} {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M0.328856 8.76291L7.47033 15.6834C7.90594 16.1055 8.61193 16.1055 9.04754 15.6834C9.48316 15.2613 9.48316 14.5771 9.04754 14.155L3.81161 9.08107H22.8841C23.5 9.08107 24 8.59655 24 7.99974C24 7.40293 23.5 6.91841 22.8841 6.91841H3.81161L9.04754 1.84449C9.48316 1.42236 9.48316 0.738215 9.04754 0.316081C8.83081 0.106054 8.54326 3.20937e-07 8.25786 3.20937e-07C7.97246 3.20937e-07 7.68706 0.106054 7.46818 0.316081L0.326709 7.23657C-0.108904 7.65871 -0.108904 8.34285 0.326709 8.76499L0.328856 8.76291Z" fill="white"/>
</svg>


);

IconArrow.propTypes = {
    rotation: PropTypes.oneOf(['up', 'down', 'right', 'left'])
};
